'use strict';

var TOTAL_PAGE_LINKS_DEFAULT = 6;

const lodashRange = require('lodash/range.js');

// inclusive range
function range(start, end) {
    return lodashRange(start, end + 1);
}

/**
 * Returns positions of back, forward, page numbers, and ellipsis for paginators
 * @param numberOfPages
 * @param currentPage
 */
module.exports = function (numberOfPages, currentPage, totalPageLinks) {
    var currentLinks = [];
    totalPageLinks = totalPageLinks || TOTAL_PAGE_LINKS_DEFAULT;

    function getPage(i) {
        return {
            type: 'page',
            key: i,
            pageNumber: i,
            isSelected: i === currentPage,
        };
    }

    if (currentPage > 1) {
        currentLinks.push({
            type: 'back',
            key: 'back',
        });
    }

    if (numberOfPages <= totalPageLinks - 1) {
        // If there are fewer than the total pages, only display links for those pages every time.
        if (numberOfPages > 1) {
            currentLinks = currentLinks.concat(range(1, numberOfPages).map(getPage));
        }
    } else if (currentPage <= totalPageLinks / 2) {
        // If the current page is in the beginning section
        // For 6 links: (1, 2, 3, 4, ..., 100)
        // For 12 link: (1, 2, 3, 4, 5, 6, 7, 8, 9, 10, ..., 100)
        currentLinks = currentLinks.concat(range(1, totalPageLinks - 2).map(getPage));
        currentLinks.push({ type: 'ellipsis', key: 'end-ellipsis' });
        currentLinks.push(getPage(numberOfPages));
    } else if (currentPage > numberOfPages - totalPageLinks / 2) {
        // If the current page is in the end section
        // For 6 links: (1, ..., 97, 98, 99, 100)
        // For 12: (1, ..., 94, 95, 96, 97, 98, 99, 100)
        currentLinks.push(getPage(1));
        currentLinks.push({ type: 'ellipsis', key: 'start-ellipsis' });
        currentLinks = currentLinks.concat(
            range(numberOfPages - totalPageLinks + 3, numberOfPages).map(getPage)
        );
    } else {
        // If the current page is in the middle somewhere
        // For 6 links: (1,..., 49, 50, 51, ..., 100)
        // For 12 links: (1, ..., 46, 47, 48, 49, 50, 51, 52, 53, 54, ..., 100)
        currentLinks.push(getPage(1));
        currentLinks.push({ type: 'ellipsis', key: 'start-ellipsis' });
        var middleOffset = (totalPageLinks - 4) / 2;
        currentLinks = currentLinks.concat(
            range(currentPage - middleOffset, currentPage + middleOffset).map(getPage)
        );
        currentLinks.push({ type: 'ellipsis', key: 'end-ellipsis' });
        currentLinks.push(getPage(numberOfPages));
    }

    if (currentPage < numberOfPages) {
        currentLinks.push({
            type: 'forward',
            key: 'forward',
        });
    }

    return currentLinks;
};
